module.exports = __webpack_public_path__ + "static/media/minusRed.f5e87bf3.svg";